import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { TrashIcon } from '@radix-ui/react-icons';

import { DropdownMenuItem } from '../../primitives/dropdown-menu';

type DropdownMenuItemDeleteProps = React.ComponentPropsWithoutRef<
  typeof DropdownMenuPrimitive.Item
>;

export function DropdownMenuItemDelete(props: DropdownMenuItemDeleteProps) {
  return (
    <DropdownMenuItem template="grid-icon-content" {...props}>
      <div className="flex justify-center">
        <TrashIcon className="size-4 text-destructive" />
      </div>
      <span className="text-destructive">Eliminar</span>
    </DropdownMenuItem>
  );
}
